// removed by extract-text-webpack-plugin
module.exports = {"container":"magazines_3UzZo","page":"magazines_3jPg8","page-couter":"magazines_rsyTB","images-loader":"magazines_2-G3P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/publish/MobilePublishComponent.scss
// module id = 995
// module chunks = 1